<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [
        
      ]
    };
  },
  mounted() {
      this.title= this.$t('menuitems.wechat.wechatmp.text')
      this.items=[
        {
          text: this.$t('menuitems.wechat.text'),
          href: "/"
        },
        {
          text: this.$t('menuitems.wechat.wechatmp.text'),
          active: true
        }
      ]
      
    //   this.page.title=this.$t('menuitems.devices.lists')
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>